import { render, staticRenderFns } from "./LegalDocu.vue?vue&type=template&id=84de8550"
import script from "./LegalDocu.vue?vue&type=script&lang=js"
export * from "./LegalDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports